import { connect } from 'react-redux';
import { dropFirstTimeFlag, FirstTimeFlag, hasFirstTimeFlag, } from '../../../redux/firstTimeFlags';
var mapStateToProps = function (state, props) { return ({
    showFTUE: hasFirstTimeFlag(state, FirstTimeFlag.IsArtShopBuyButtonMessageNotShown),
}); };
var mapDispatchToProps = {
    onDismissFTUE: function () {
        return dropFirstTimeFlag({
            flag: FirstTimeFlag.IsArtShopBuyButtonMessageNotShown,
        });
    },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ArtShopBuyButton.container.js.map